import React from 'react';
import { useConfig } from '../../DataStore/ConfigContext';

const ConfigHome = ({ menuItems }) => {
    const { dispatch } = useConfig();
    const themeColor = "#4F46E5";

    const handleItemClick = (id) => {
        dispatch({ type: 'activeMenu', payload: id });
    };

    return (
        <div className="row no-gutters">
            {Array.isArray(menuItems) && menuItems.map((button, index) => (
                <div className="col-sm-4 p-2" key={index}>
                    <div 
                        onClick={() => handleItemClick(button.id)}
                        className="bg-white d-flex flex-column align-items-center justify-content-center p-4 text-center cursor-pointer config-tile"
                        style={{
                            borderRadius: '16px',
                            border: '1px solid #E2E8F0',
                            height: '160px',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}
                    >
                        <div 
                            className="mb-3 d-flex align-items-center justify-content-center"
                            style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '12px',
                                backgroundColor: '#EEF2FF'
                            }}
                        >
                            <i className={`fa ${button.icon}`} style={{ fontSize: '20px', color: themeColor }}></i>
                        </div>
                        <span style={{ 
                            fontWeight: '600', 
                            fontSize: '14px', 
                            color: '#1A202C' 
                        }}>
                            {button.label}
                        </span>
                    </div>
                </div>
            ))}
            <style>{`
                .config-tile:hover {
                    border-color: ${themeColor} !important;
                    transform: translateY(-4px);
                    box-shadow: 0 10px 15px -3px rgba(79, 70, 229, 0.1);
                }
                .config-tile:hover i {
                    transform: scale(1.1);
                    transition: 0.3s;
                }
            `}</style>
        </div>
    );
};

export default ConfigHome;